import { Platform, Linking } from 'react-native';

export const openExternalUrl = async (url: string) => {
  try {
    if (Platform.OS === 'web') {
      (globalThis as any)?.open?.(url, '_blank');
      return true;
    }
    const supported = await Linking.canOpenURL(url);
    if (supported) {
      await Linking.openURL(url);
      return true;
    }
    return false;
  } catch {
    return false;
  }
};


